import {AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, DestroyRef, inject, QueryList} from '@angular/core';
import {ControlRef, FormRowRef} from '@aviary/forms/fields/form-fields.types';
import {CONTROL_REF, FORM_ROW_REF} from '@aviary/injection-tokens/aviary-only.tokens';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {extractControlsFromControlRefs, extractControlsFromFormRowRefs, extractUniqueControlsFrom} from '@aviary/forms/form.helpers';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'mx-form-row',
  host: {
    class: 'flex flex-row'
  },
  template: `
    <ng-content/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{provide: FORM_ROW_REF, useExisting: FormRowComponent}]
})
export class FormRowComponent implements AfterContentInit, FormRowRef {

  @ContentChildren(CONTROL_REF) private directControlRefs: QueryList<ControlRef>;
  @ContentChildren(FORM_ROW_REF) private nestedFormRowRefs: QueryList<FormRowRef>;

  public controls: ReadonlyArray<ExtendedFormControl> = [];

  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  public ngAfterContentInit(): void {
    this.rebuildControls();

    this.directControlRefs?.changes
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.rebuildControls();
      });

    this.nestedFormRowRefs?.changes
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.rebuildControls();
      });
  }

  private rebuildControls(): void {
    const directControls: ExtendedFormControl[] = extractControlsFromControlRefs(this.directControlRefs);
    const nestedFormRowControls: ExtendedFormControl[] = extractControlsFromFormRowRefs(this.nestedFormRowRefs);

    // eslint-disable-next-line no-restricted-syntax -- FormRowRef (and thus this component) has a controls property, which is not what we need to restrict.
    this.controls = extractUniqueControlsFrom(directControls, nestedFormRowControls);
  }
}
